import { apiGet } from '@/lib/http/client';
import type { PipelineTemplate } from '@/lib/proposals/core/types';

const baseUrl = (orgId: number) =>
  `/api/orgs/${orgId}/pipelines/pipeline_templates/`;

/**
 * List the methodology templates available for a record type. The backend
 * requires the `entity_type_name` query param (the record the pipeline is for,
 * e.g. `ahoy_deal`) and returns an empty list for a type with no templates.
 */
export function listPipelineTemplates(
  orgId: number,
  entityTypeName: string,
  signal?: AbortSignal
): Promise<PipelineTemplate[]> {
  return apiGet<PipelineTemplate[]>(
    `${baseUrl(orgId)}?entity_type_name=${encodeURIComponent(entityTypeName)}`,
    undefined,
    undefined,
    signal
  );
}

export function getPipelineTemplate(
  orgId: number,
  key: string,
  entityTypeName: string,
  signal?: AbortSignal
): Promise<PipelineTemplate> {
  return apiGet<PipelineTemplate>(
    `${baseUrl(orgId)}${encodeURIComponent(key)}/?entity_type_name=${encodeURIComponent(entityTypeName)}`,
    undefined,
    undefined,
    signal
  );
}
